import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { OrgUserSignVisualizationSettings } from '@/models/user-settings.models';

export const userSettingsService = {
  get,
  orgGet,
  save,
  orgSave,
  changeLocale,
  getOrgUserSignVisSettings
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'UserSettings'
};

function extract(r) {
  return r.data;
}

async function get() {
  return axios.get(`${model.baseUrl}${model.controller}/get`).then(extract);
}

async function orgGet() {
  return axios.get(`${model.baseUrl}${model.controller}/orgGet`).then(extract);
}

async function save(settings: object) {
  var dataModel = { data: JSON.stringify(settings) };
  return axios.post(`${model.baseUrl}${model.controller}/save`, dataModel).then(extract);
}

async function orgSave(settings: object) {
  var dataModel = { data: JSON.stringify(settings) };
  return axios.post(`${model.baseUrl}${model.controller}/orgSave`, dataModel).then(extract);
}

async function changeLocale(locale: string) {
  return axios.patch(`${model.baseUrl}${model.controller}/changeLocale`, { locale }).then(extract);
}

async function getOrgUserSignVisSettings(): Promise<OrgUserSignVisualizationSettings> {
  let { data } = await axios.get<OrgUserSignVisualizationSettings>(
    `${model.baseUrl}${model.controller}/GetOrgUserSignVisSettings`);

  return new OrgUserSignVisualizationSettings(data);
}
